export function removeCSSClass(ele: HTMLElement, cls: string): void {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele: HTMLElement, cls: string): void {
    ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname: string): string => {
    return process.env.PUBLIC_URL + pathname;
};
